import { request } from '@/shared/api/request'

export const getData = (data, params) => {
	return request({ url: `/assessment/dict/${data}`, method: 'GET', params })
}
